export const attachmentText = {
  preview: { key: 'attachment_preview_name', fallback: { en: 'Preview {name}', he: 'תצוגה מקדימה של {name}' } },
  uploading: { key: 'attachment_uploading_name', fallback: { en: 'Uploading {name}', he: 'מעלים את {name}' } },
  remove: { key: 'attachment_remove_name', fallback: { en: 'Remove {name}', he: 'הסרת {name}' } },
  failed: { key: 'attachment_upload_failed', fallback: { en: 'Upload failed', he: 'ההעלאה נכשלה' } },
  unavailable: {
    key: 'attachment_preview_unavailable',
    fallback: { en: 'Preview unavailable', he: 'אין תצוגה מקדימה' },
  },
  download: { key: 'download', fallback: { en: 'Download', he: 'הורדה' } },
}
